import React from 'react';
import { Sparkles, Code2, BookOpen, BarChart3, Lightbulb, PenTool } from 'lucide-react';
import { Logo, GUEST_MSG_LIMIT } from './chatUtils';

const categories = [
  {
    icon: PenTool,
    label: 'Writing',
    prompt: 'Help me write a compelling product description for a new AI-powered analytics tool',
  },
  {
    icon: Code2,
    label: 'Code',
    prompt: 'Write a Python function to process and analyze a CSV file efficiently',
  },
  {
    icon: BookOpen,
    label: 'Research',
    prompt: 'Summarize the latest developments in large language models and their applications',
  },
  {
    icon: BarChart3,
    label: 'Analysis',
    prompt: 'Analyze the pros and cons of microservices vs monolithic architecture',
  },
  {
    icon: Lightbulb,
    label: 'Strategy',
    prompt: 'Create a go-to-market strategy for a B2B SaaS product targeting enterprise clients',
  },
  {
    icon: Sparkles,
    label: 'Creative',
    prompt: 'Generate 5 unique startup ideas that combine AI with everyday consumer problems',
  },
];

export default function WelcomeScreen({ onSuggestion, isGuest }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-4 h-full min-h-[50vh]" data-testid="welcome-screen">
      <div className="mb-10 text-center animate-msg-in">
        <Logo size="lg" className="mx-auto mb-5 opacity-80" />
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-content tracking-tight mb-2">
          How can I help you today?
        </h1>
        <p className="text-content-3 text-sm font-sora max-w-md mx-auto leading-relaxed">
          Start a conversation or pick a suggestion below
        </p>
        {isGuest && (
          <p className="text-xs mt-3 text-content-3 font-mono">{GUEST_MSG_LIMIT} free messages available</p>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-w-2xl w-full px-2">
        {categories.map((cat, i) => {
          const Icon = cat.icon;
          return (
            <button
              key={i}
              onClick={() => onSuggestion(cat.prompt)}
              className="group text-left p-4 rounded-2xl border border-line bg-overlay hover:bg-overlay-hover hover:border-line-2 transition-all duration-300 active:scale-[0.98]"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`suggestion-${i}`}
            >
              <Icon className="w-4 h-4 text-content-3 group-hover:text-emerald-500 transition-colors duration-300 mb-2.5" strokeWidth={1.5} />
              <p className="text-xs font-sora font-medium text-content-2 group-hover:text-content transition-colors duration-300">
                {cat.label}
              </p>
              <p className="text-[11px] font-sora text-content-3 mt-1 line-clamp-2 group-hover:text-content-2 transition-colors duration-300 leading-relaxed">
                {cat.prompt}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
